export interface FactboxSubValue {
  title: string;
  value: string;
}

export enum FactboxFontSizes {
  SMALL = 'small',
  LARGE = 'large',
}
